module.exports = __webpack_public_path__ + "static/media/timespool.f2dbd489.png";